/* eslint-disable*/
import { connect } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import moment from 'moment';
import { Button } from '@/Components/ui/button';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import BackdropLoader from '../../Components/Loaders/BackdropLoader';
import { ListTable } from '../../Components/ListTable';
import allVendorServices from '../../Services/Form Services/allvendor.services';
import { formActions, modalActions } from '../../Actions';
import DynamicTableModal from '../../Components/Modals/DynamicTableModal/DynamicTableModal';
import { notificationServices } from '../../Services';
import { urls } from '../../Constants';
import { filtersInfoChip, getActionColumn, getBase64FromFileBlob, handleResponseStreamDownload } from '../../Helpers';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import drawerActions from '@/Actions/drawer.actions';
import ExportFiltersDrawer from '@/Components/Drawers/ExportFiltersDrawer/ExportFiltersDrawer';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Ban, Download, Filter, Pencil, Plus, RefreshCcw, Upload } from 'lucide-react';
import { Tooltip } from '@mui/material';
import GlobalSearch from '@/Components/globalSearch/search';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Buyer',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Term',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expiry Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
];

const ADDITIONAL_COLUMNS = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];

const COL_MAP = {
	ID: 'id',
	Vendor: 'vendorName',
	Buyer: 'vendorName',
	'Payment Term': 'paymentTerm',
	'Expiry Date': 'expiryDate',
	Status: 'status',
	Edit: 'id',
	Cancel: 'id',
};

// Status pill colours, same pill style as Vendor Organisations (rows are no longer tinted by status)
const STATUS_PILL = {
	Valid: 'bg-green-100 text-green-700',
	'Expiring within 1 month': 'bg-amber-100 text-amber-700',
	'Expiring tomorrow': 'bg-orange-100 text-orange-700',
	'Expiring today': 'bg-orange-100 text-orange-700',
	Expired: 'bg-red-100 text-red-700',
	Cancelled: 'bg-gray-100 text-gray-500',
};

const ListVendorContractPage = (props) => {
	const {
		toggleModal,
		toggleAlert,
		type,
		toggleExportFiltersDrawer,
		stores,
		fetchStoreList,
		toggleFiltersDrawer,
	} = props;
	const [contractData, setContractData] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const { userConfig } = useAuth();
	const {level} = userConfig?.userDetails || {};
	const [filters, setFilters] = useState({});
	const [searchText, setSearchText] = useState('');
	const contractUploadInputRef = useRef(null);
	const history = useHistory();
	const location = useLocation();
	
	useEffect(() => {
		fetchStoreList({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
					type: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const fetchContracts = async () => {
		try {
			setLoading(true);
			const req = {
				pageType: type,
			};
			const response = await allVendorServices.ListVendorContract(req);
			if (response?.statusCode === 200) {
				const contracts = response?.data?.map((contract) => {
					const expiryDate = moment(contract?.expiryDate);
					let status = 'Valid';

					if (contract?.isDeleted) {
						status = 'Cancelled';
					} else if (expiryDate.isSame(moment(), 'day')) {
						status = 'Expiring today';
					} else if (expiryDate.isBefore(moment())) {
						status = 'Expired';
					} else if (expiryDate.isBefore(moment().add(1, 'day'))) {
						status = 'Expiring tomorrow';
					} else if (expiryDate.isBefore(moment().add(1, 'month'))) {
						status = 'Expiring within 1 month';
					}
					return {
						...contract,
						status,
					};
				});
				setContractData(contracts);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
	};
	// useEffect(() => {
	// 	if (!fetchonMount && !history?.location?.state?.prevPath) {
	// 		fetchContracts();
	// 	}
	// }, []);

	// useEffect(() => {
	// 	if (!fetchonMount && !history?.location?.state?.prevPath) {
	// 		fetchContracts();
	// 	}
	// }, [type]);

	const handleFind = async (data) => {
		// Expiry Date is optional: it starts empty and only filters once a range is picked
		const expiryRange = data?.dateRange?.active && data?.dateRange?.from && data?.dateRange?.to
			? data.dateRange
			: null;
		setFilters(expiryRange ? data : { ...data, dateRange: undefined });
		try {
			setLoading(true);
			const filter = {
				// ...data,
				store : data?.store?.id,
				...(type === 'BUYER' ? {
					vendors : data?.buyer?.id,
				} : {
					vendors : data?.vendors?.id,
				}),
				
				productCategories : data?.productCategories?.id,
				products : data?.products?.id,
				// The API only applies the range when active is true (it was never sent, so the filter did nothing)
				dateRangeFilter: {
					active: !!expiryRange,
					timeType: data?.timeType?.value,
					from: expiryRange ? moment(expiryRange.from).format('YYYY-MM-DD') : null,
					to: expiryRange ? moment(expiryRange.to).format('YYYY-MM-DD') : null,
				},
				pageType: type,
			};
			const response = await allVendorServices.VendorContractFilter(filter);
			if (response?.statusCode === 200) {
				const contracts = response?.data?.map((contract) => {
					const expiryDate = moment(contract?.expiryDate);
					let status = 'Valid';

					if (contract?.isDeleted) {
						status = 'Cancelled';
					} else if (expiryDate.isSame(moment(), 'day')) {
						status = 'Expiring today';
					} else if (expiryDate.isBefore(moment())) {
						status = 'Expired';
					} else if (expiryDate.isBefore(moment().add(1, 'day'))) {
						status = 'Expiring tomorrow';
					} else if (expiryDate.isBefore(moment().add(1, 'month'))) {
						status = 'Expiring within 1 month';
					}
					return {
						...contract,
						status,
					};
				});
				setContractData(contracts);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
		return data;
	};

	const handleAddClick = () => {
		if (type === 'BUYER') {
			history.push(`/console2/buyer/contract/create?type=${type}`, {prevPath: location?.pathname + location?.search});
		} else {
			history.push(`/console2/vendor/contract/create?type=${type}`, {prevPath: location?.pathname + location?.search});
		}
	};

	const handleContractUpload = async (event) => {
		const file = event?.target?.files?.[0];
		if (!file) {
			return;
		}
		try {
			setLoading(true);
			const base64File = await new Promise((resolve) => {
				getBase64FromFileBlob(file, resolve);
			});
			const response = await allVendorServices.uploadVendorContract({
				contractData: base64File,
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message || 'Vendor contracts uploaded successfully',
				});
				await fetchContracts();
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message || 'Unable to upload vendor contracts',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || 'Unable to upload vendor contracts',
			});
		} finally {
			if (event?.target) {
				event.target.value = '';
			}
			setLoading(false);
		}
	};

	const downloadVendorContractTemplate = () => {
		const headers = [
			'UY Entity Id',
			'Entity Code',
			'City Name',
			'State Name',
			'Region Name',
			'Contract End Date',
			'Payment Terms',
			'UY Variant ID',
			'SKU Code',
			'Rate',
		];
		const sampleRow = [
			'',
			'VENDOR_001',
			'',
			'',
			'North',
			'12/31/2026',
			'Net 30',
			'',
			'SKU_001',
			'125.50',
		];
		const csvContent = [headers, sampleRow].map((row) => row.join(',')).join('\n');
		const fileBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const downloadLink = document.createElement('a');
		downloadLink.href = window.URL.createObjectURL(fileBlob);
		downloadLink.download = 'vendor_contract_upload_template.csv';
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
	};

	const fetchContractInfo = async (contractId) => {
		try {
			setLoading(true);
			const response = await allVendorServices.VendorContractInfo({
				contractId,
			});
			if (response?.statusCode === 200) {
				toggleModal(true, response?.data);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
		return {};
	};

	const handleViewClick = (contract) => {
		fetchContractInfo(contract?.id);
	};

	const handleDelete = async (contractId) => {
		try {
			setLoading(true);
			const response = await allVendorServices.VendorContractDelete({
				contractId,
				type,
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'contract cancelled successfully',
				});
				const remainingContract = contractData.map((contract) => {
					if (contract.id === contractId) {
						// eslint-disable-next-line no-param-reassign
						contract.status = 'Cancelled';
					}
					return contract;
				});

				setContractData(remainingContract);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error Occured',
			});
		} finally {
			setLoading(false);
		}
	};

	const SPECIAL_ITEMS = {
		'Expiry Date': (date) => {
			return moment(date).format('YYYY-MM-DD');
		},
		Status: (status) => {
			return (
				<span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${STATUS_PILL[status] ?? 'bg-gray-100 text-gray-500'}`}>
					{status}
				</span>
			);
		},
		Actions: (contractId) => {
			const contractAction = contractData.find((contractTmp) => {
				return contractTmp.id === contractId;
			});
			if (contractAction?.status === 'Cancelled') {
				return null;
			}
			return (
				<div className='flex items-center gap-2'>
					<Button
						size='sm'
						variant='outline'
						className='h-7 px-2'
						title='Edit contract'
						aria-label='Edit contract'
						onClick={() => {
							if (type === 'BUYER') {
								history.push(
									`${urls.EXTENSION}${urls.BUYER_CONTRACT_CREATE}?isEdit=True&contractId=${contractId}&type=${type}`,
									{
										prevPath: location?.pathname + location?.search,
									}
								);
							} else {
								history.push(
									`${urls.EXTENSION}${urls.VENDOR_CONTRACT_CREATE}?isEdit=True&contractId=${contractId}&type=${type}`,
									{
										prevPath: location?.pathname + location?.search,
									}
								);
							}
						}}
					>
						<Pencil size={13} />
					</Button>
					<Button
						size='sm'
						variant='outline'
						className='h-7 px-2 text-red-500 hover:text-red-600 hover:border-red-300'
						title='Cancel contract'
						aria-label='Cancel contract'
						onClick={() => {
							toggleAlert(true, {
								heading: 'Cancel Contract?',
								handleConfirm: () => {
									handleDelete(contractId);
									toggleAlert(false);
								},
								colorReverse: false,
								cancelText: 'No',
								confirmText: 'Yes',
								message: `Are you sure you want to Cancel contract for ${contractAction?.vendorName ?? 'vendor'}?`,
							});
						}}
					>
						<Ban size={13} />
					</Button>
				</div>
			);
		},
	};
	const handleExport = async(filters) => {
		if(!filters?.store?.id) return notificationServices?.generateNotification({
			type: 'error',
			message: 'Please select a Store for Export',
		});
		setLoading(true);
		try{
			const req = {
				data: {
					storeId : filters?.store?.id,
				}
			};
			if(type === 'BUYER'){
				const response = await allVendorServices?.exportBuyerContract(req);
				if(response.status === 200){
					handleResponseStreamDownload(response, 'Buyer Contract.csv');
				}
			}else {
				const response = await allVendorServices?.exportVendorContract(req); 
				if(response.status === 200){
					handleResponseStreamDownload(response, 'Vendor Contract.csv');
				}
			}
		}catch(error){
			notificationServices?.generateNotification({
				type: 'error',
				message: error,
			});
		}finally{
			setLoading(false);
		}
	}
	// export function 
	// const openExportDrawer = () => {
	// 	toggleExportFiltersDrawer(true, {
	// 		heading: type === 'BUYER' ? 'Export Buyer Contract' : 'Export Vendor Contract',
	// 		// note: 'Filters are disabled for now, they will be LIVE Soon!',
	// 		onConfirm: (args) => {
	// 			const { filtersState } = args ?? {};
	// 			handleExport(filtersState);
	// 		},
	// 		filterData: [
	// 			{
	// 				type: 'singleSelect',
	// 				dependentOn: -1,
	// 				compData: stores
	// 					// ?.filter((ele) => {
	// 					// 	return ele?.type === 'BASE';
	// 					// })
	// 					?.map((ele) => {
	// 						return {
	// 							id: ele?.id,
	// 							label: ele?.name,
	// 							title: ele?.name,
	// 							value: ele?.id,
	// 						};
	// 					}),
	// 				selectBy: 'id',
	// 				label: ' Select Stores',
	// 				selectedValueKey: 'storeId',
	// 				dateFormat: null,
	// 				disabled: false,
	// 				defaultState: null,
	// 				mandatory: true,
	// 			},
	// 		],
	// 	});
	// };

	const filtersInfo = {
		header : {
			store : false,
			product : false,
			date: false,
		},
		store : {
			text: 'Region',
			show: true,
		},
		product : {
			text: 'Product',
			show: true,
		},
		dateRangeOnly : {
			text: 'Expiry Date',
			show: true,
			cleanable: true,
		},
		...(type === 'BUYER' ? {
			buyer : {
				text: 'Buyer',
				show: true,
			},
		} : {
			vendor : {
				text: 'Vendor',
				show: true,
			},
		}),
		productCategory : {
			text: 'Product Category',
			show: true,
		},
	};
	const exportInfo = {
		showExportBtn : true,
	};

	const contractLabel = type === 'BUYER' ? 'Buyer Contract' : 'Vendor Contract';
	// Text search on the page itself: narrows the loaded contracts by vendor / buyer name
	const searchQuery = searchText.trim().toLowerCase();
	const visibleContracts = searchQuery
		? contractData.filter((contract) => (contract?.vendorName ?? '').toLowerCase().includes(searchQuery))
		: contractData;

	return (
		<div className='flex flex-col w-full'>
			<DynamicTableModal isBuyer={type === 'BUYER'} />
			<BackdropLoader isLoading={isLoading} showProgress />
			<ExportFiltersDrawer />
			<ImagesFinder
				onSubmit={handleFind}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				cleanable={{ store: true }}
				// No expiry range until one is picked (Reset returns here too)
				initialState={{ dateRange: { active: false, from: null, to: null } }}
			/>
			{/* Header, search and filter row - same layout as Internal Sales Orders */}
			<div className='p-4 w-full flex flex-col gap-2'>
				<div className='flex justify-between items-center w-full gap-2'>
					<span className='font-bold text-[16px]'>{contractLabel}</span>
					<div className='flex flex-wrap items-center gap-2'>
						{type !== 'BUYER' && level !== 1 && (
							<>
								<input
									ref={contractUploadInputRef}
									type='file'
									accept='.csv,text/csv'
									style={{ display: 'none' }}
									onChange={handleContractUpload}
								/>
								<Button
									variant='outline'
									onClick={() => {
										contractUploadInputRef.current?.click();
									}}
									className='flex items-center gap-2'
								>
									<Upload size={16} />
									Upload Vendor Contract
								</Button>
								<Button
									variant='outline'
									onClick={downloadVendorContractTemplate}
									className='flex items-center gap-2'
								>
									<Download size={16} />
									Download Template
								</Button>
							</>
						)}
						{level !== 1 && (
							<Button
								onClick={handleAddClick}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								<Plus size={16} />
								{`Add ${contractLabel}`}
							</Button>
						)}
					</div>
				</div>
				<div className='flex gap-3 w-full justify-start items-center'>
					<div className='w-[90%]'>
						<GlobalSearch
							searchDropDown={false}
							placeholderText={`Search by ${type === 'BUYER' ? 'buyer' : 'vendor'} name`}
							setSearchValue={setSearchText}
						/>
					</div>
					<Tooltip title={`Refresh ${contractLabel}s`}>
						<RefreshCcw
							className='size-5 cursor-pointer'
							onClick={() => {
								handleFind(filters);
							}}
						/>
					</Tooltip>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								handleDataExport : (req) => handleExport(req),
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
				{filtersInfoChip(filtersInfo, filters)}
			</div>
			<div className='w-full overflow-x-auto'>
				<ListTable
					columns={TABLE_COLUMNS?.filter((ele) => {
						if (type === 'BUYER') {
							return ele?.title !== 'Vendor';
						}
						if(type === 'VENDOR'){
							return ele?.title !== 'Buyer';
						}
						return true;
					})}
					colMap={type === 'BUYER'
						? Object.fromEntries(Object.entries(COL_MAP).filter(([key]) => key !== 'Vendor'))
						: Object.fromEntries(Object.entries(COL_MAP).filter(([key]) => key !== 'Buyer'))}
					actions={getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level)}
					handleViewClick={handleViewClick}
					special={SPECIAL_ITEMS}
					data={visibleContracts}
					allowExport={false}
					showBtnContainer={false}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { userList } = state.auth;
	const stores = state?.form?.FILTERED_STORES?.data?.LIST;
	return {
		userPermissions,
		navState,
		userList,
		stores,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleDynamicTableModal,
	toggleAlert: modalActions.toggleAlert,
	fetchUserList: authActions.fetchUserList,
	fetchStoreList: formActions.gateway,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};
export default connect(mapStateToProps, mapDispatchToProps)(ListVendorContractPage);
